import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.cuentasBancarias.detalle', {
    url: '/{idCliente}@{idEmpresa}',
    abstract: true,
    data: {
      titleProxy: 'finances.cuentasBancarias.detalle.cuentas',
    },
    resolve: {
      clientes: ['$catalogos', '$stateParams', function ($catalogos, $stateParams) {
        return $catalogos.get('clientes')
          .then(function (clientes) {
            return clientes.find(function (item) {
              return item.ID_Cliente === $stateParams['idCliente']
            })
          })
      }],
      idCliente: ($stateParams) => $stateParams.idCliente,
      idEmpresa: ($stateParams) => $stateParams.idEmpresa,
    },
    template,
    controllerAs: '$ctrl',
    controller (clientes) {
      var $ctrl = this

      $ctrl.data = clientes
    },
  })
})





// WEBPACK FOOTER //
// ./src/finanzas/_/bancosCuentas/detalle/detalle.js